import v3ApiClient from "./client";

const SCHEDULE_DRAFT_BASE_PATH = "/v3/schedule/drafts";
const SCHEDULE_DRAFT_AGENT_NAME = "SCHEDULE_DRAFT_OPTIMIZER";

export const analyzeScheduleDraft = (draftId, trackId, payload = {}) => {
    return v3ApiClient.post(`${SCHEDULE_DRAFT_BASE_PATH}/${draftId}/analyze`, { ...payload, track_id: trackId });
};

export const scheduleDraftApi = {
    getScheduleDraftList: (params = {}) => v3ApiClient.get(SCHEDULE_DRAFT_BASE_PATH, { params }),

    getScheduleDraftById: (draftId, params = {}) => v3ApiClient.get(`${SCHEDULE_DRAFT_BASE_PATH}/${draftId}`, { params }),

    createScheduleDraft: (payload) => v3ApiClient.post(SCHEDULE_DRAFT_BASE_PATH, payload),

    updateScheduleDraft: (draftId, payload) => v3ApiClient.put(`${SCHEDULE_DRAFT_BASE_PATH}/${draftId}`, payload),

    deleteScheduleDraft: (draftId) => v3ApiClient.delete(`${SCHEDULE_DRAFT_BASE_PATH}/${draftId}`),

    getScheduleDraftTracks: (draftId) => v3ApiClient.get(`${SCHEDULE_DRAFT_BASE_PATH}/${draftId}/tracks`),

    createScheduleDraftTrack: (draftId, payload) => v3ApiClient.post(`${SCHEDULE_DRAFT_BASE_PATH}/${draftId}/tracks`, payload),

    updateScheduleDraftTrack: (draftId, trackId, payload) => v3ApiClient.put(`${SCHEDULE_DRAFT_BASE_PATH}/${draftId}/tracks/${trackId}`, payload),

    deleteScheduleDraftTrack: (draftId, trackId) => v3ApiClient.delete(`${SCHEDULE_DRAFT_BASE_PATH}/${draftId}/tracks/${trackId}`),

    reorderScheduleDraftTracks: (draftId, trackOrder) => v3ApiClient.post(`${SCHEDULE_DRAFT_BASE_PATH}/${draftId}/tracks/reorder`, { track_order: trackOrder }),

    cloneScheduleDraftTrack: (draftId, sourceTrackId, name) => v3ApiClient.post(`${SCHEDULE_DRAFT_BASE_PATH}/${draftId}/tracks/${sourceTrackId}/clone`, { name }),

    saveScheduleDraftTrackAsHistory: (draftId, trackId, payload = {}) => v3ApiClient.post(`${SCHEDULE_DRAFT_BASE_PATH}/${draftId}/tracks/${trackId}/save-as-history`, payload),

    restoreScheduleDraftTrack: (draftId, trackId) => v3ApiClient.post(`${SCHEDULE_DRAFT_BASE_PATH}/${draftId}/tracks/${trackId}/restore`),

    adoptScheduleDraftAgentTrack: (draftId, trackId, payload = {}) => v3ApiClient.post(`${SCHEDULE_DRAFT_BASE_PATH}/${draftId}/tracks/${trackId}/adopt`, payload),

    finalizeScheduleDraftTrack: (draftId, trackId) => v3ApiClient.post(`${SCHEDULE_DRAFT_BASE_PATH}/${draftId}/tracks/${trackId}/finalize`),

    listScheduleDraftPublications: (draftId, params = {}) => v3ApiClient.get(`${SCHEDULE_DRAFT_BASE_PATH}/${draftId}/publications`, { params }),

    getScheduleDraftPublication: (draftId, publicationId) => v3ApiClient.get(`${SCHEDULE_DRAFT_BASE_PATH}/${draftId}/publications/${publicationId}`),

    addScheduleDraftFlightToTrack: (draftId, trackId, payload) => v3ApiClient.post(`${SCHEDULE_DRAFT_BASE_PATH}/${draftId}/tracks/${trackId}/flights`, payload),

    updateScheduleDraftFlight: (draftId, flightId, payload) => v3ApiClient.put(`${SCHEDULE_DRAFT_BASE_PATH}/${draftId}/flights/${flightId}`, payload),

    deleteScheduleDraftFlight: (draftId, flightId) => v3ApiClient.delete(`${SCHEDULE_DRAFT_BASE_PATH}/${draftId}/flights/${flightId}`),

    moveScheduleDraftFlight: (draftId, flightId, payload) => v3ApiClient.post(`${SCHEDULE_DRAFT_BASE_PATH}/${draftId}/flights/${flightId}/move`, payload),

    autoCalculateScheduleDraftFlights: (draftId, payload) => v3ApiClient.post(`${SCHEDULE_DRAFT_BASE_PATH}/${draftId}/commands/auto-calculate`, payload),

    getScheduleDraftFlightNumberSuggestions: (draftId, pairs = []) => v3ApiClient.post(`${SCHEDULE_DRAFT_BASE_PATH}/${draftId}/queries/flight-number-suggestions`, { pairs }),

    analyzeScheduleDraft,

    previewScheduleDraftSourceFlights: (draftId, payload) => v3ApiClient.post(`${SCHEDULE_DRAFT_BASE_PATH}/${draftId}/sources/flights/preview`, payload),

    importScheduleDraftSourceFlights: (draftId, payload) => v3ApiClient.post(`${SCHEDULE_DRAFT_BASE_PATH}/${draftId}/commands/import-source-flights`, payload),

    previewScheduleDraftTableImport: (draftId, payload) => v3ApiClient.post(`${SCHEDULE_DRAFT_BASE_PATH}/${draftId}/sources/table/preview`, payload),

    importScheduleDraftTableFlights: (draftId, payload) => v3ApiClient.post(`${SCHEDULE_DRAFT_BASE_PATH}/${draftId}/commands/import-table-flights`, payload),

    attachSourceReferenceTrack: (draftId, payload) => v3ApiClient.post(`${SCHEDULE_DRAFT_BASE_PATH}/${draftId}/commands/attach-reference-track`, payload),

    ensureComparisonBaseline: (draftId, trackId, payload = { run_auto_match: false }) => v3ApiClient.post(`${SCHEDULE_DRAFT_BASE_PATH}/${draftId}/tracks/${trackId}/comparison-baseline/ensure`, payload),

    bindComparisonBaseline: (draftId, trackId, payload) => v3ApiClient.put(`${SCHEDULE_DRAFT_BASE_PATH}/${draftId}/tracks/${trackId}/comparison-baseline`, payload),

    getTrackMatches: (draftId, trackId, params = {}) => v3ApiClient.get(`${SCHEDULE_DRAFT_BASE_PATH}/${draftId}/tracks/${trackId}/matches`, { params }),

    createMatch: (draftId, trackId, payload) => v3ApiClient.post(`${SCHEDULE_DRAFT_BASE_PATH}/${draftId}/tracks/${trackId}/matches`, payload),

    autoMatchTrack: (draftId, trackId, payload = {}) => v3ApiClient.post(`${SCHEDULE_DRAFT_BASE_PATH}/${draftId}/tracks/${trackId}/matches/auto`, payload),

    autoMatchPreview: (draftId, trackId, payload = {}) => v3ApiClient.post(`${SCHEDULE_DRAFT_BASE_PATH}/${draftId}/tracks/${trackId}/matches/auto-match-preview`, payload),

    validateMatchPreview: (draftId, trackId, payload = {}) => v3ApiClient.post(`${SCHEDULE_DRAFT_BASE_PATH}/${draftId}/tracks/${trackId}/matches/validate-match-preview`, payload),

    commitMatches: (draftId, trackId, payload = {}) => v3ApiClient.post(`${SCHEDULE_DRAFT_BASE_PATH}/${draftId}/tracks/${trackId}/matches/commit-matches`, payload),

    getCompareConfirmation: (draftId, trackId, params = {}) => v3ApiClient.get(`${SCHEDULE_DRAFT_BASE_PATH}/${draftId}/tracks/${trackId}/compare-confirmation`, { params }),

    confirmCompare: (draftId, trackId, payload = {}) => v3ApiClient.post(`${SCHEDULE_DRAFT_BASE_PATH}/${draftId}/tracks/${trackId}/compare-confirmation`, payload),

    updateMatch: (draftId, trackId, matchId, payload) => v3ApiClient.put(`${SCHEDULE_DRAFT_BASE_PATH}/${draftId}/tracks/${trackId}/matches/${matchId}`, payload),

    deleteMatch: (draftId, trackId, matchId, params = {}) => v3ApiClient.delete(`${SCHEDULE_DRAFT_BASE_PATH}/${draftId}/tracks/${trackId}/matches/${matchId}`, { params }),

    batchResetMatches: (draftId, trackId, payload = {}) => v3ApiClient.post(`${SCHEDULE_DRAFT_BASE_PATH}/${draftId}/tracks/${trackId}/matches/reset`, payload),

    validateMatches: (draftId, trackId, params = {}) => v3ApiClient.get(`${SCHEDULE_DRAFT_BASE_PATH}/${draftId}/tracks/${trackId}/matches/validate`, { params }),

    getPublishValidation: (draftId, trackId) => v3ApiClient.get(`${SCHEDULE_DRAFT_BASE_PATH}/${draftId}/tracks/${trackId}/publish-validation`),

    triggerScheduleDraftAgent: (draftId, payload) => v3ApiClient.post(`${SCHEDULE_DRAFT_BASE_PATH}/${draftId}/commands/agent-trigger`, payload),

    getScheduleDraftAgentSessions: (draftId) => v3ApiClient.get(`${SCHEDULE_DRAFT_BASE_PATH}/${draftId}/commands/agent-sessions`),

    getScheduleDraftAgentStrategyPrompts: (params = {}) => v3ApiClient.get(`${SCHEDULE_DRAFT_BASE_PATH}/queries/agent-strategy-prompts`, {
        params: {
            agent_name: SCHEDULE_DRAFT_AGENT_NAME,
            entry_type: "PROMPT",
            is_active: true,
            page: 1,
            page_size: 100,
            ...params,
        },
    }),
};

scheduleDraftApi.getList = scheduleDraftApi.getScheduleDraftList;
scheduleDraftApi.getById = scheduleDraftApi.getScheduleDraftById;
scheduleDraftApi.create = scheduleDraftApi.createScheduleDraft;
scheduleDraftApi.update = scheduleDraftApi.updateScheduleDraft;

export default scheduleDraftApi;
